import { CSSProperties } from "react";
import { Theme } from "./types";

const MTE_SM = 480;
const MTE_MD = 720;

/**
 * Returns the modal border radius based on device type
 * Mobile devices: 0
 * Desktop/Laptop: 24
 */
export const getBorderRadius = (): number => {
    const userAgent = navigator?.userAgent?.toLowerCase();
    const isMobileUA = /iphone|ipad|ipod|android|webos|blackberry|windows phone/i.test(userAgent);
    const hasTouchScreen = 'ontouchstart' in window || navigator?.maxTouchPoints > 0;
    
    const isMobile = isMobileUA || hasTouchScreen;
    
    return isMobile ? 0 : 24;
}

export const screenSizes: { id: string, size: number }[] = [
    {
        id: "MTE_SM",
        size: MTE_SM,
    },
    {
        id: "MTE_MD",
        size: MTE_MD,
    },
]

/**
 * When the width is smaller than 
 * 
 */
export const minWidthMatcher = (): string => {
    for (let i = 0; i < screenSizes.length; i++) {
        const { id, size } = screenSizes[i];
        if (window.matchMedia(`(min-width: ${size}px`).matches) {
            return id
        }
    }
    return "ANY"
}

export const containerStyle: CSSProperties = {
    paddingRight: 0,
    paddingLeft: 0,
    marginRight: "auto",
    marginLeft: "auto",
    maxHeight: 812
}

export const containerMediaStyles: { [id: string]: CSSProperties } = {
    MTE_SM: {
        width: 480
    },
    MTE_MD: {
        width: 720
    },
    ANY: {
        width: "100%",
        height: "100%",
        maxWidth: "100%",
        maxHeight: "100%"
    },
}

export const appWrapperStyle: CSSProperties = {
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 999999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100vw",
    height: CSS.supports("height: 100dvh") ? "100dvh" : window.innerHeight + "px",
    maxHeight: CSS.supports("height: 100dvh") ? "100dvh" : window.innerHeight + "px",
    background: "rgba(0,0,0,0.5)",
    cursor: "pointer"
}

/**
 * Returns the wrapper background color the modal should paint while the
 * inner app loads. Light defaults to white (matches the legacy iframe
 * apps which always render light). Dark and auto resolve to transparent
 * so the modal does not flash white before the dark next-gen iframe
 * paints over it — the surrounding `appWrapperStyle` overlay
 * (`rgba(0,0,0,0.5)`) provides the loading-state visual instead.
 */
const getModalBackgroundColor = (theme: Theme): string =>
    theme === "light" ? "#FFF" : "transparent";

export const getModalStyle = (theme: Theme = "light"): CSSProperties => ({
    padding: 0,
    backgroundColor: getModalBackgroundColor(theme),
    height: "calc(100% - 100px)",
    maxWidth: "calc(100% - 30px)",
    borderRadius: getBorderRadius()
})

/**
 * Default light-mode modal style retained as a named export so existing
 * imports keep compiling. Prefer `getModalStyle(theme)` in render paths
 * that have the resolved theme available.
 */
export const modalStyle: CSSProperties = getModalStyle("light")

export const iframeWrapperStyle: CSSProperties = {
    width: "100%",
    height: "100%",
    border: "none",
    overflow: "hidden"
};

export const iframeStyle: CSSProperties = {
    width: "100%",
    height: "100%",
    border: "none",
    margin: 0,
    padding: 0,
    overflow: "hidden",
    borderRadius: getBorderRadius(),
};